import { CarFront, Fuel, TrafficCone } from 'lucide-react'
import type { NavSection } from '../../core/router/navConfig'

/** Navegação da área Central de Informações, até 04/11/2026 chamada Abastecimento
 *  (27/10/2026): o setor de combustível lança as multas de trânsito e, desde
 *  01/11/2026, os sinistros, e eles caem no DP, que só lê. Desde 04/11/2026 os
 *  Abastecimentos da Logística moram também aqui, em primeiro, e só aqui com o
 *  Relatório de Alertas (Samuel). A chave da área continua `abastecimento`.
 *
 *  Entrar na área não dá a tela: cada uma pede a própria key, que chega pelo cargo. Ver
 *  docs/areas/05-como-adicionar.md. */
export const abastecimentoNav: NavSection[] = [
  {
    title: 'Lançamentos',
    titleKey: 'nav.section.fuelEntries',
    items: [
      { label: 'Abastecimento', labelKey: 'nav.fuelCentral', path: '/abastecimento/abastecimentos', icon: Fuel, ready: true, permission: 'abastecimento.view' },
      { label: 'Multas', labelKey: 'nav.fines', path: '/abastecimento/multas', icon: TrafficCone, ready: true, permission: 'multa.view' },
      { label: 'Sinistros', labelKey: 'nav.claims', path: '/abastecimento/sinistros', icon: CarFront, ready: true, permission: 'sinistro.view' },
    ],
  },
]
